import React from 'react';
import { GlobalBanner, GlobalBannerProps } from './GlobalBanner';

type GlobalBannerContainerProps = {
    banners: GlobalBannerProps[];
};

export const GlobalBannerContainer = ({ banners }: GlobalBannerContainerProps) => {
    return (
        <>
            {banners.map((banner) => {
                if (banner.visibleOn === 'uld' || banner.visibleOn === 'both') {
                    return <GlobalBanner key={banner.id} {...banner} />;
                }
                return null;
            })}
        </>
    );
};
